// extracted by mini-css-extract-plugin
var _1 = "print-module__controls___E6tGU";
export { _1 as "controls" }
